"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultTransactionRecords = void 0;
var transactionRecord = {
    date: '22/07/2020',
    id: 321232,
    price: 73000000,
    priceChangePercent: 1.8,
    block: 'Shan On House',
    floor: '30',
    name: 'Shan On House',
    phase: '',
    size: 406,
    sizeUnit: 'g',
    unit: 'B',
    priceChangeSinceDate: '01/12/2006',
    priceAnnualReturn: 0.1,
};
exports.defaultTransactionRecords = [
    transactionRecord,
    transactionRecord,
    transactionRecord,
    transactionRecord,
    transactionRecord,
];
